import React from 'react';
import { Pagination } from 'antd';
import CardInst from '../../../ant/ui/CardInst';
import {Cards} from "../../../ant/ui/Cards";

const PublicListingCard = ({ listings, changePage }) => {
  return (
    <div
      // className={css.privateList}
      style={
        {
          // padding: '0 10px',
            marginTop: '-20px'
        }
      }
    >
        <Cards listings={listings} vip={[]}/>
      <div
        // className={css.subVipRow}
        style={{
          width: '100%',
          // display: 'flex',
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        {/*{listings?.entries?.length > 0 &&*/}
        {/*  listings.entries.map((item, key) => {*/}
        {/*    // if (item.covers.length === 0 && item.videos.length === 0) {*/}
        {/*    //   return null;*/}
        {/*    // }*/}
        {/*    return <CardInst item={item} key={key} />;*/}
        {/*  })}*/}
      </div>
      <div
        style={{
          clear: 'both',
        }}
      ></div>
      {listings?.entries?.length > 0 && (
        <div
          style={{
            textAlign: 'center',
            marginTop: '30px',
          }}
        >
          <Pagination
            simple
            style={{
              display: 'inline-block',
              margin: '0 auto',
            }}
            pageSize={12}
            total={listings.count}
            onChange={(page, pageSize) => {
              changePage(page);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default PublicListingCard;
